"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.knowledge.list': 'Knowledge Base',
    'route.knowledge.create': 'Add Knowledge',
    'route.knowledge.edit': 'Edit Knowledge',
    'route.knowledge.preview': 'Knowledge Details',
    'route.knowledge.bulk_upload': 'Bulk Upload Knowledge',
};
